import {
  openTrailEditToolbar as diToolingOpenEditToolbar,
  closeTrailEditToolbar as diToolingCloseEditToolbar,
  DiToolingState
} from '@alltrails/di-tooling';
import { useAppDispatch, useAppSelector } from '@/utils/redux';

export default function useTrailEditToolbar() {
  const dispatch = useAppDispatch();
  const diTooling = useAppSelector(state => state.diTooling);

  const openTrailEditToolbar = (toolbarSection?: DiToolingState['trailEditToolbarFocusSection']) =>
    dispatch(diToolingOpenEditToolbar(toolbarSection));
  const closeTrailEditToolbar = () => dispatch(diToolingCloseEditToolbar());

  return {
    showTrailEditToolbar: diTooling?.showTrailEditToolbar,
    trailEditToolbarFocusSection: diTooling?.trailEditToolbarFocusSection,
    openTrailEditToolbar,
    closeTrailEditToolbar
  };
}
